var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { getActionFromKey, getUpdatedIndex, isScrollable, maintainScrollVisibility, MenuActions, uniqueId, filterOptions } from '@/common/utils/multiselectUtilities';
var MultiselectAccessible = /** @class */ (function (_super) {
    __extends(MultiselectAccessible, _super);
    function MultiselectAccessible() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Active option index
        _this.activeId = 0;
        /**
         * Options which match the given inputValue, and which are shown to the user.
         * */
        _this.filteredOptions = [];
        _this.selectedOptions = [];
        /**
         * Value used for filtering the available options.
         * */
        _this.inputValue = '';
        // Menu state
        _this.open = false;
        // Flag to set focus on next render completion
        _this.callFocus = false;
        // Prevent menu closing before click completed
        _this.ignoreBlur = false;
        return _this;
    }
    Object.defineProperty(MultiselectAccessible.prototype, "inputRef", {
        // reference to input element
        get: function () {
            return this.$refs["inputref"];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MultiselectAccessible.prototype, "listboxRef", {
        // reference to listbox
        get: function () {
            return this.$refs["listboxref"];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MultiselectAccessible.prototype, "activeOptionRef", {
        // reference to active option
        get: function () {
            return this.$refs["activeoptionref"];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MultiselectAccessible.prototype, "activeOptionId", {
        get: function () { return this.open ? this.dropdownId + "-" + this.activeId : ''; },
        enumerable: false,
        configurable: true
    });
    MultiselectAccessible.prototype.created = function () {
        this.setFilteredOptions(this.options);
        this.setSelectedOptions();
    };
    MultiselectAccessible.prototype.watchOptions = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setFilteredOptions(options);
                this.setSelectedOptions();
                return [2 /*return*/];
            });
        });
    };
    MultiselectAccessible.prototype.setFilteredOptions = function (options) {
        this.filteredOptions = filterOptions(options, this.inputValue);
        if (this.filteredOptions.length > 0) {
            this.activeId = this.filteredOptions[0].id;
        }
    };
    MultiselectAccessible.prototype.setSelectedOptions = function () {
        var _this = this;
        this.selectedOptions = [];
        if (this.value && this.value.length > 0) {
            this.value.forEach(function (x) {
                var validOption = _this.options.find(function (y) { return y.id == x.id; });
                if (validOption) {
                    _this.selectedOptions.push(validOption);
                }
            });
        }
    };
    MultiselectAccessible.prototype.updated = function () {
        if (this.callFocus === true) {
            this.inputRef.focus();
            this.callFocus = false;
        }
        if (this.open && isScrollable(this.listboxRef)) {
            maintainScrollVisibility(this.activeOptionRef, this.listboxRef);
        }
    };
    MultiselectAccessible.prototype.onInput = function () {
        var _this = this;
        var curValue = this.inputRef.value;
        this.filteredOptions = filterOptions(this.options, curValue);
        if (this.inputValue !== curValue) {
            this.inputValue = curValue;
            //set activeId to first matching option
            //(or leave it alone, if the active option is already in the matching set)
            var filterCurrentOption = this.filteredOptions.filter(function (option) { return option === _this.options.find(function (x) { return x.id == _this.activeId; }); });
            if (this.filteredOptions.length > 0 && !filterCurrentOption.length) {
                this.onOptionChange(this.options.find(function (x) { return x.id == _this.filteredOptions[0].id; }).id);
            }
        }
        var menuState = this.filteredOptions.length > 0;
        if (this.open !== menuState) {
            this.updateMenuState(menuState, false);
        }
    };
    MultiselectAccessible.prototype.onInputKeyDown = function (event) {
        var _this = this;
        var max = this.filteredOptions.length - 1;
        var currentOption = this.filteredOptions.find(function (x) { return x.id == _this.activeId; });
        var currentIndex = this.filteredOptions.indexOf(currentOption);
        var action = getActionFromKey(event, this.open);
        switch (action) {
            case MenuActions.Next:
            case MenuActions.Last:
            case MenuActions.First:
            case MenuActions.Previous:
                event.preventDefault();
                return this.onOptionChange(this.filteredOptions[getUpdatedIndex(currentIndex, max, action)].id);
            case MenuActions.CloseSelect:
                event.preventDefault();
                if (max >= 0) {
                    return this.updateOption(this.activeId);
                }
                return;
            case MenuActions.Close:
                event.preventDefault();
                return this.updateMenuState(false);
            case MenuActions.Open:
                return this.updateMenuState(true);
        }
    };
    MultiselectAccessible.prototype.onInputBlur = function () {
        if (this.ignoreBlur) {
            this.ignoreBlur = false;
            return;
        }
        this.updateMenuState(false, false);
        this.$emit("close");
    };
    MultiselectAccessible.prototype.onOptionClick = function (id) {
        this.onOptionChange(id);
        this.updateOption(id);
    };
    MultiselectAccessible.prototype.onOptionMouseDown = function (event, optionSelected) {
        if (this.selectedFull && !optionSelected) {
            event.preventDefault();
        }
        else {
            this.ignoreBlur = true;
            this.callFocus = true;
        }
    };
    MultiselectAccessible.prototype.onOptionChange = function (id) {
        this.activeId = id;
    };
    MultiselectAccessible.prototype.removeOption = function (index) {
        this.selectedOptions.splice(index, 1);
        this.$emit("input", this.selectedOptions);
    };
    MultiselectAccessible.prototype.updateOption = function (id) {
        var option = this.filteredOptions.find(function (x) { return x.id == id; });
        var optionIndex = this.selectedOptions.indexOf(option);
        var isSelected = optionIndex > -1;
        if (isSelected) {
            this.removeOption(optionIndex);
            this.filteredOptions = this.options;
            this.inputValue = '';
        }
        else {
            // prevent selection if max options selected
            if (!this.selectedFull) {
                this.selectedOptions.push(option);
                this.filteredOptions = this.options;
                this.inputValue = '';
                this.$emit("input", this.selectedOptions);
            }
            this.activeId = option.id;
        }
    };
    MultiselectAccessible.prototype.updateMenuState = function (open, callFocus) {
        if (callFocus === void 0) { callFocus = true; }
        this.open = open;
        this.callFocus = callFocus;
    };
    Object.defineProperty(MultiselectAccessible.prototype, "selectedFull", {
        get: function () {
            return this.maxSelected > 0
                ? this.selectedOptions.length >= this.maxSelected
                : false;
        },
        enumerable: false,
        configurable: true
    });
    MultiselectAccessible.prototype.optionSelected = function (option) {
        var selected = this.filteredOptions.find(function (x) { return x.id == option.id; });
        return this.selectedOptions.indexOf(selected) > -1;
    };
    __decorate([
        Prop({ type: Array, required: true }),
        __metadata("design:type", Array)
    ], MultiselectAccessible.prototype, "options", void 0);
    __decorate([
        Prop({ type: Array, default: [] }),
        __metadata("design:type", Array)
    ], MultiselectAccessible.prototype, "value", void 0);
    __decorate([
        Prop({ type: String, default: function () { return uniqueId(); } }),
        __metadata("design:type", String)
    ], MultiselectAccessible.prototype, "dropdownId", void 0);
    __decorate([
        Prop({ type: String, default: "Selected" }),
        __metadata("design:type", String)
    ], MultiselectAccessible.prototype, "selectedText", void 0);
    __decorate([
        Prop({ type: String, default: "Remove" }),
        __metadata("design:type", String)
    ], MultiselectAccessible.prototype, "removeText", void 0);
    __decorate([
        Prop({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], MultiselectAccessible.prototype, "readOnly", void 0);
    __decorate([
        Prop({ type: Number, default: undefined }),
        __metadata("design:type", Number)
    ], MultiselectAccessible.prototype, "maxSelected", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], MultiselectAccessible.prototype, "placeholder", void 0);
    __decorate([
        Watch('options'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", Promise)
    ], MultiselectAccessible.prototype, "watchOptions", null);
    MultiselectAccessible = __decorate([
        Component({
            name: 'MultiselectAccessible',
        })
    ], MultiselectAccessible);
    return MultiselectAccessible;
}(Vue));
export default MultiselectAccessible;
